import script from "./DetalhesPurchaseOrderEnxuto.vue?vue&type=script&setup=true&lang=js"
export * from "./DetalhesPurchaseOrderEnxuto.vue?vue&type=script&setup=true&lang=js"

import "./DetalhesPurchaseOrderEnxuto.vue?vue&type=style&index=0&id=562004c4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-562004c4"]])

export default __exports__